<template>
  <div class="sidebar">
    <router-link to="/admin" class="brand-logo-wrapper">
      <template v-if="!isLogoLoading">
        <img
          :src="logo.status ? defaultImage : logo.image"
          style="width: 170px; height: 60px; border-radius: 5px; pointer-events: none;"
          alt="main"
        />
      </template>
      <Spinner v-else :theme="primary" class="mx-auto d-block" />
    </router-link>

    <router-link
      to="/admin"
      class="bookings-today--wrapper"
      :style="{ 'background-color': secondary }"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="150"
        height="108"
        viewBox="0 0 150 108"
        aria-hidden="true"
      >
        <defs>
          <clipPath id="a">
            <rect
              width="150"
              height="108"
              rx="5"
              transform="translate(37 100)"
              fill="#e8f4fa"
            />
          </clipPath>
        </defs>
        <g transform="translate(-37 -100)" clip-path="url(#a)">
          <path
            d="M884.949,425.909v-10.4c0-5.976-4.17-8.093-8.093-8.093H853.573c-3.921,0-8.093,2.116-8.093,8.093v10.4a6.613,6.613,0,0,0-4.98,6.412V449c0,4.919,3.3,6.848,6.536,7.035v4.233a2.232,2.232,0,0,0,2.241,2.241h2.3a2.232,2.232,0,0,0,2.241-2.241v-4.233h22.847v4.233a2.232,2.232,0,0,0,2.241,2.241h2.3a2.232,2.232,0,0,0,2.241-2.241v-4.233c4.794-.249,6.536-3.735,6.536-7.035V432.259a6.81,6.81,0,0,0-5.043-6.349Zm-37.227-10.4c0-5.105,3.673-5.914,5.851-5.914h23.282c2.179,0,5.852.747,5.852,5.852V425.66a6.635,6.635,0,0,0-6.038,6.6v1.556H853.76v-1.556a6.635,6.635,0,0,0-6.038-6.6Zm28.885,20.543v7.719H853.76v-7.719Zm-25.026,24.216h-2.3v-4.233h2.3Zm29.57,0h-2.3v-4.233h2.3ZM887.75,449h-.062c0,2.179-.809,4.856-4.855,4.856H847.6c-2.179,0-4.855-.81-4.855-4.856V432.259a4.42,4.42,0,1,1,8.839,0V444.9a1.116,1.116,0,0,0,1.121,1.12H877.79a1.116,1.116,0,0,0,1.121-1.12V432.259a4.42,4.42,0,1,1,8.839,0Zm0,0"
            transform="translate(-697.925 -308.074)"
            :fill="primary"
            :stroke="primary"
            stroke-width="1"
            opacity="0.1"
          />
        </g>
      </svg>
      <div class="bookings-today__content">
        <div class="bookings-today__date">
          {{
            new Intl.DateTimeFormat("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric"
            }).format(new Date())
          }}
        </div>
        <h5 class="bookings-today mb-0" :style="{ color: primary }">
          <span class="bookings-today--count">
            <template v-if="totalBookingsToday > 0">
              {{ totalBookingsToday }}
            </template>
            <template v-else>-</template>
          </span>
          <span v-if="totalBookingsToday > 0" class="bookings-today--label">
            {{ 1 >= totalBookingsToday ? "Booking" : "Bookings" }} Today
          </span>
        </h5>
      </div>
    </router-link>

    <ul class="menu--list">
      <li class="menu--list-item list-group">
        <router-link to="/admin/dashboard">Home</router-link>
      </li>
      <li class="menu--list-item has-actions">
        <router-link to="/admin/members">Members</router-link>
        <div class="list-action">
          <ActionButton
            :theme="{ primary, secondary, event, danger }"
            label="+"
            @customEvent="
              handleAddClick({
                modal: `admin-${$route.matched[1].name}-add-member`,
                path: 'add-member',
                name: 'add-member',
                hasBackdropEvent: false
              })
            "
          />
        </div>
      </li>
      <li class="menu--list-item has-actions">
        <router-link to="/admin/products">Products</router-link>
        <div class="list-action">
          <ActionButton
            :theme="{ primary, secondary, event, danger }"
            label="+"
            @customEvent="
              handleAddClick({
                modal: `admin-${$route.matched[1].name}-add-package`,
                path: 'add-package',
                name: 'add-package',
                hasBackdropEvent: false
              })
            "
          />
        </div>
      </li>
      <li class="menu--list-item list-group has-actions">
        <router-link to="/admin/events">Events</router-link>
        <div class="list-action">
          <ActionButton
            :theme="{ primary, secondary, event, danger }"
            label="+"
            @customEvent="
              handleAddClick({
                modal: `admin-${$route.matched[1].name}-add-event`,
                path: 'add-event',
                name: 'add-event',
                hasBackdropEvent: false
              })
            "
          />
        </div>
      </li>
      <li class="menu--list-item list-group">
        <router-link to="/admin/reports">Reports</router-link>
      </li>
      <li class="menu--list-item list-group">
        <router-link to="/admin/settings">Settings</router-link>
      </li>
    </ul>
    <div class="sidebar--footer">
      <router-link
        to="/admin/logs"
        class="footer-link"
        :style="{ color: primary }"
        >Activity</router-link
      >
      <a
        class="footer-link"
        :style="{ color: primary }"
        @click="
          handleAddClick({
            modal: `admin-${$route.matched[1].name}-report-bug`,
            path: 'report-bug',
            name: 'report-bug',
            hasBackdropEvent: false
          })
        "
        >Report an Issue</a
      >
    </div>
  </div>
</template>

<script>
import { dateUTC } from "@/helpers/date";
import moment from "@/helpers/moment";
import orderBy from "lodash/orderBy";
import { setTimeout } from "timers";
import { mapGetters } from "vuex";

const Spinner = () => import("@/components/Spinner");
const ActionButton = () => import("@/components/ActionButton");

export default {
  name: "Sidebar",
  components: {
    ActionButton,
    Spinner
  },
  async created() {
    this.$store.dispatch("GET_TOTAL_BOOKINGS_TODAY");
    await this.$store.dispatch("fetchOptions", "defaultlogo");
    this.isDefaultLogo = this.options;

    /**
     * SOCKET: Update booking/order counter on concierge sidebar
     */
    await this.$socket.on("notifyOrder", async data => {
      const tenant = window.location.host.split(".")[0];
      if (data.tenant == tenant) {
        this.$toastr.options = {
          preventDuplicates: true,
          preventOpenDuplicates: true
        };
        this.$toastr.success("You've received a new booking");
      }
      this.fetchOrdersToday();
      this.$store.dispatch("GET_TOTAL_BOOKINGS_TODAY");
    });

    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  },
  data() {
    return {
      currentDate: moment(dateUTC(new Date())).format("MMMM DD, YYYY"),
      isDefaultLogo: [{ value: { image: null } }, { value: { status: false } }],
      isLogoLoading: true,
      locations: [],
      defaultImage: require("@/assets/media/brand.svg")
    };
  },
  mounted() {
    Promise.all([this.fetchOrdersToday(), this.checkActiveLinks()]).then(() => {
      this.isLogoLoading = false;
    });
  },
  watch: {
    primary: function() {
      this.checkActiveLinks();
    },
    $route() {
      this.checkActiveLinks();
    }
  },
  methods: {
    ...mapGetters({
      currentLogo: "currentLogo"
    }),
    async fetchOrdersToday(page = 1, size = 10) {
      await this.$http
        .get(`/locations?page[number]=${page}&page[size]=${size}`)
        .then(response => {
          const { data: location } = response.data;
          this.locations = orderBy(
            [...this.locations, ...location],
            ["id"],
            ["asc"]
          );
        });
      let options = {
        queryParams: "date=" + this.currentDate + `&location=&status=0`
      };
      this.$store.dispatch("fetchOrders", options);
    },
    handleAddClick(params) {
      this.$emit("modalClicked", params);
    },
    handleShowAllClick(params) {
      const { page } = params;
      this.$router.push({ path: "/admin/" + page });
    },
    checkActiveLinks() {
      const listItem = document.querySelectorAll(".menu--list-item a");
      setTimeout(() => {
        Array.from(listItem).map(e => {
          if (e.classList.contains("router-link-active")) {
            if (e.innerText != "Members") {
              this.$store.dispatch("HISTORY_ACTIVE_USER", null);
              this.$store.dispatch("SET_REPORT_HISTORY", 0);
            }
            if (e.innerText == "Reports") {
              this.$store.dispatch("SET_REPORT_FILTER", {});
            }
            e.style.color = this.primary;
          } else {
            e.style.color = "#232323";
          }
        });
      }, 100);
    },
    handleVisibilityChange() {
      if (document.hidden) return;
      this.$store.dispatch("GET_TOTAL_BOOKINGS_TODAY");
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    options() {
      return this.$store.state.concierge.optionsList.data;
    },
    totalBookingsToday() {
      return this.$store.state.admin.totalBookingsToday;
    },
    logo() {
      let logo = { image: null, status: true };

      if (!this.options) {
        return logo;
      }

      const defaultLogo = this.options.find(i => i.key === "defaultlogo.main");
      const brandLogo = this.options.find(i => i.key === "defaultlogo.sub");

      if (defaultLogo && defaultLogo.value.status === false) {
        logo.image = brandLogo.value.image;
        logo.status = false;
      }

      return logo;
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  height: 100%;
  position: relative;
  font-family: "Gotham", sans-serif;

  &--footer {
    bottom: 0;
    display: flex;
    padding: 5px 0;
    position: absolute;
    width: 100%;
    @media (max-height: 660px) {
      position: relative;
    }
    .footer-link {
      color: $brand-primary;
      font-size: $font-size-sm;
      position: relative;
      &:first-child {
        &:after {
          color: $gray-200;
          content: "|";
          position: absolute;
          right: -13px;
        }
      }
      &:last-child {
        cursor: pointer;
        position: absolute;
        right: 0;
        &:hover {
          color: $brand-primary;
          text-decoration: underline;
        }
      }
    }
  }
}
.brand-logo-wrapper {
  display: block;
  margin-bottom: 50px;
  text-decoration: none;
  img {
    object-fit: contain;
  }
  .icon--brand {
    color: $brand-primary;
    display: block;
    fill: currentColor;
    height: 2.5rem;
    stroke: currentColor;
    stroke-width: 0;
    width: 8rem;
  }
}
.bookings-today {
  align-items: center;
  display: inline-grid;
  gap: 0.5rem;
  grid-auto-flow: column;
  line-height: 1;
  &--wrapper {
    border-radius: 0.5rem;
    display: block;
    padding: 20px;
    position: relative;
    outline: 2px solid transparent;
    &:hover {
      text-decoration: none;
      .bookings-today--label {
        text-decoration: underline;
      }
    }
    &:focus-visible {
      outline-color: var(--primary);
    }
    & > svg {
      position: absolute;
      right: 2px;
      top: 0;
      pointer-events: none;
    }
    & > h5 {
      color: $brand-primary;
      font-size: $font-size-sm;
      & > span {
        display: block;
        font-size: $font-size-xl;
        margin-bottom: 10px;
      }
    }
  }
  &__date {
    font-size: $font-size-sm;
    color: $gray-700;
    margin-bottom: 0.25rem;
  }
  &--label {
    font-family: "Gotham";
    font-size: $font-size-sm;
    vertical-align: middle;
  }
  &--count {
    font-size: $font-size-xl;
    vertical-align: middle;
  }
}
.menu--list {
  list-style-type: none;
  margin-top: 30px;
  padding: 0;
  &-item {
    font-size: $font-size-sm;
    margin-bottom: 25px;
    position: relative;
    &.list-part {
      margin-top: 40px;
    }
    &.list-group {
      margin-bottom: 30px;
    }
    a {
      color: $gray-900;
      font-family: "Gotham";
      font-weight: 500;
      &.router-link-active {
        color: $brand-primary;
      }
    }
    span {
      font-family: "Gotham", sans-serif;
    }
    &.has-actions {
      .list-action {
        border-left: 1px solid $gray-200;
        display: flex;
        padding-left: 15px;
        position: absolute;
        right: -8px;
        top: 0;
        button {
          height: 25px;
          margin-top: 0;
          padding: 0;
          width: 25px;
          &:first-child {
            margin-right: 15px;
          }
        }
      }
    }
  }
}
.submenu--list {
  list-style-type: none;
  padding-left: 15px;
  li {
    margin-top: 20px;
    a {
      color: $gray-700;
      font-family: "Gotham", sans-serif;
      font-size: $font-size-xs;
      &.router-link-active {
        color: $brand-primary;
      }
    }
  }
}
</style>
